
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'

@Component
export default class BudgetView extends Vue{

    @Prop({default:""})
    activityId!:any

    @Prop({default:""})
    budgetTemplateId!:any

    @Prop({default:()=>[]})
    milestones!:Array<any>

    @Prop()
    reportView!:boolean

    @Prop()
    budgetLumpSum!:boolean
    /*
    @Prop()
    ganttData!:any

    showSplit:boolean = true

    showLineSum:boolean = true

    unitCost:boolean = true

    dayRate:boolean = true

    randomColors:Array<any> = ["red","green","blue"]

    activeDept=0

    get activitiesByDepartment():any{
        let dataToReturn:Array<any> = []
        this.ganttData.projects.forEach((a:any)=>{
            let rowIndex = dataToReturn.findIndex(ad=>ad.departmentId==a.departmentId)
            if(rowIndex<0){
                dataToReturn.push({departmentId:a.departmentId,name:this.getDepartmentName(a.departmentId),activities:[a]})
            }else{
                dataToReturn[rowIndex].activities.push(a)
            }
        })
        
        return dataToReturn
    }

    get sections():any{
        if(this.budgetTemplateId==""||this.budgetTemplateId==null)return []
        let budgetTemplate = this.$store.getters["budgetTemplateModule/getAllTemplates"].find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.budgetTemplateId)
        if(budgetTemplate) return budgetTemplate.sections
        return []
    }

    get columns():any{
        if(this.budgetLumpSum){
            if(this.showLineSum)this.showLineSum = false
            return [{id:this.activityId,name:"Total"}]
        }else{
            if(!this.showLineSum)this.showLineSum = true
            return this.milestones
        }
    }

    get departments(){
        return this.$store.state.departmentModule.departments
    }

    getDepartmentName(id:string){
        let department = this.departments.find((d:any) => d.id == id)
        if(department) return department.name
        return ""
    }

    computeDuration(start:string,end:string){
        if(start==""||end=="")return 0
        let startDateMill = (new Date(start)).getTime()
        let endDateMill = (new Date(end)).getTime()
        let diff = endDateMill - startDateMill
        if(diff<1)return 1
        return Math.round(diff/(1000 * 3600 * 24))
    }

    */

    get trueSectionChange():any{
        return this.activityId||this.budgetTemplateId
    }

    get activity():any{
        return this.$store.getters["ActivityModule/getActivityById"](this.activityId)
    }

    get rows():any{
        if(this.budgetTemplateId==""||this.budgetTemplateId==null)return []
        let budgetTemplate = this.$store.getters["budgetTemplateModule/getAllTemplates"].find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.budgetTemplateId)
        if(budgetTemplate){
            let rows:Array<any> = []
            budgetTemplate.sections.forEach((s:any)=>{
                rows.push(...s.budgetLineItems.map((b:any)=>({key:b.id,label:b.lineItem,sectionId:s.sectionName})))
            })
            return rows
        }
        return []
    
    }

    get sections():any{
        if(this.budgetTemplateId==""||this.budgetTemplateId==null||this.trueSectionChange=="")return []
        let budgetTemplate = this.$store.getters["budgetTemplateModule/getAllTemplates"].find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.budgetTemplateId)
        if(budgetTemplate) return budgetTemplate.sections
        return []
    }

    get selectedProject() {
        return this.$store.getters['projectModule/getSelectedProject']
    }

    get getProjectIndexById(){
        return this.$store.getters["projectModule/getProjectIndexById"](this.selectedProject.id)
    }

    get computedTableFields(){
        let milestonesIds = this.milestones.map(m=>m.id)
        if(this.budgetLumpSum) return this.tableFields.filter(t=>!milestonesIds.includes(t.key))
        return this.tableFields
    }

    private tableData:Array<any> = []

    private tableFields:Array<any> = [
        {key:"sectionId",label:"",stickyColumn: true,isRowHeader:true, tdClass:this.sectionIdColumnStyleCallback},
        {key:"activitySumForThisBudgetLine",label:"Total",stickyColumn: true,isRowHeader:true, tdClass:this.sectionIdColumnStyleCallback}
    ]

    lumpSumLineItemChanged(item:any,data:any){
        if(this.reportView){
            //handle he report view state here
        }else{
            this.$store.dispatch('ActivityModule/updateActivityBudget',{sequenceId:this.selectedProject.sequenceId,projectIndex:this.getProjectIndexById,id:this.activityId,sectionId:item.sectionId,lineItem:{lineValue:item.activitySumForThisBudgetLine,lineItemId:item.id}})
        }
    }

    lineItemChanged(item:any,milestoneId:any){
        if(this.reportView){
            this.$emit("line-value-changed",{milestoneId:milestoneId,budgetTemplateId:this.budgetTemplateId,lineItem:{lineValue:(this.milestones.reduce((a,m)=>a+(parseInt(item[m.id])||0),0)),lineItemId:item.id}})
        }else{
            this.$store.dispatch('ActivityModule/updateActivityBudget',{sequenceId:this.selectedProject.sequenceId,projectIndex:this.getProjectIndexById,id:this.activityId,sectionId:item.sectionId,lineItem:{lineValue:(this.milestones.reduce((a,m)=>a+(parseInt(item[m.id])||0),0)),lineItemId:item.id}})
            this.$store.commit('MilestoneModule/updateMilestoneBudget',{id:milestoneId,budgetTemplateId:this.budgetTemplateId,lineItem:{lineValue:item[milestoneId],lineItemId:item.id}})
        }
    }

    @Watch("milestones",{immediate:true})
    onMilestonesChanged(){
        //milestone id is key, the budgetLine Value is the value
        let lineValues:Array<any> = []
        let milestonesIds:any = {}
        let milestonesIdsForSectionSum:any = {}

        this.milestones.forEach((thisMilestone:any) => {
            let key:string = typeof(thisMilestone.id)=="string"?thisMilestone.id:thisMilestone.id.toString()
            milestonesIds[key] = 0
            milestonesIdsForSectionSum[key] = key
        })

        this.sections.forEach((thisSection:any) => {
            thisSection.budgetLineItems.forEach((thisBudgetLineItem:any) => {
                lineValues.push({id:thisBudgetLineItem.id,...milestonesIds})
            })
        })

        //Clear the table fields and reinit each row to contain only section ids
        this.tableFields.splice(1,(this.tableFields.length-2))

        //Add the fields (to table fields) that are in the current list Milestones but not present in the previous list
        this.milestones.forEach((thisMilestone:any) => {
            let key:string = typeof(thisMilestone.id)=="string"? thisMilestone.id:thisMilestone.id.toString()
            this.tableFields.splice(this.tableFields.length-1,0,{
                label:thisMilestone.name+" (K$)",
                key:key,
                tdClass:this.sectionIdColumnStyleCallback
            })
            if(thisMilestone.budget){
                thisMilestone.budget.budgetLines.forEach((b:any) => {
                    let indexOfLineItem = lineValues.findIndex((thisLineValue:any) => b.lineItemId==thisLineValue.id)
                    if(indexOfLineItem>-1)lineValues[indexOfLineItem][thisMilestone.id] = b.lineValue
                })
            }
        })

        //reset the  table data to contain keys only for milestones in the current list
        this.tableData.forEach((thisTableRow:any,index:number) => {
            if(thisTableRow.type=="LINE_ITEM"){
                let indexOfLineItem = lineValues.findIndex((thisLineValue:any) => thisTableRow.id==thisLineValue.id)
                let newRow:any = {sectionId:thisTableRow.sectionId,lineItem:thisTableRow.lineItem,id:thisTableRow.id,type:thisTableRow.type,...lineValues[indexOfLineItem],activitySumForThisBudgetLine:thisTableRow.activitySumForThisBudgetLine}
                this.$set(this.tableData,index,newRow)
            } 
            if(thisTableRow.type=="SECTION_SUM"){
                let newRow:any = {sectionId:thisTableRow.sectionId,lineItem:thisTableRow.lineItem,type:thisTableRow.type,...milestonesIdsForSectionSum}
                this.$set(this.tableData,index,newRow)
            }
        })
    }

    @Watch("sections",{immediate:true})
    onSectionsChanged(){
        let lineValues:Array<any> = []
        let milestonesIds:any = {}
        let milestonesIdsForSectionSum:any = {}
        let incomingActivityBudgetLines = this.activity?(this.activity.budget?this.activity.budget.budgetLines:[]):[]
        
        this.milestones.forEach((thisMilestone:any) =>{
            milestonesIds[thisMilestone.id] = 0
            milestonesIdsForSectionSum[thisMilestone.id] = thisMilestone.id
        })

        this.sections.forEach((thisSection:any) => {
            thisSection.budgetLineItems.forEach((thisBudgetLineItem:any) => {
                lineValues.push({...milestonesIds,id:thisBudgetLineItem.id})
            })
        })

        
        this.milestones.forEach((thisMilestone:any) => {
            let key:string = typeof(thisMilestone.id)=="string"? thisMilestone.id:thisMilestone.id.toString()
            if(thisMilestone.budget){
                thisMilestone.budget.budgetLines.forEach((b:any) => {
                    let indexOfLineItem = lineValues.findIndex((thisLineValue:any) => b.lineItemId==thisLineValue.id)
                    if(indexOfLineItem>-1)lineValues[indexOfLineItem][thisMilestone.id] = b.lineValue
                })
            }
        })
        

        this.tableData.splice(0,this.tableData.length)
        this.sections.forEach((thisSection:any) => {

            this.tableData.push({
                sectionId:thisSection.id,
                lineItem:thisSection.sectionName,
                type:"SECTION_TITLE"        
            })

            thisSection.budgetLineItems.forEach((thisBudgetLineItem:any) => {
                let indexOfLineItem = lineValues.findIndex((thisLineValue:any) => thisBudgetLineItem.id==thisLineValue.id)
                let currentActivityLine = incomingActivityBudgetLines.find((b:any)=>b.lineItemId==thisBudgetLineItem.id)
                this.tableData.push({
                    sectionId:thisSection.id,
                    ...thisBudgetLineItem,
                    ...lineValues[indexOfLineItem],
                    activitySumForThisBudgetLine:currentActivityLine?currentActivityLine.lineValue:0,
                    type:"LINE_ITEM"
                })
            })

            this.tableData.push({
                sectionId:thisSection.id,
                lineItem:thisSection.sectionName+" Sum",
                ...milestonesIdsForSectionSum,
                type:"SECTION_SUM"
            })
        })
    }

    @Watch("budgetLumpSum")
    onBudgetLumpedSumChanged(){
        
    }

    private sectionIdColumnStyleCallback(value:any,key:any,item:any){
        switch(item.type){
            case "SECTION_SUM":
                return ["bg-dark","text-light"]
            case "SECTION_TITLE":
                return ["bg-light","text-dark","font-weight-bolder","px-0"]
            default:
                return ["font-weight-normal"]
        }
    }
}
